/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  // --- UPDATED ---
  username: "Mayank Saini",
  title: "Hi all, I'm Mayank",
  subTitle: emoji(
    "Aspiring Software Engineer with a foundational knowledge of Data Structures and Algorithms and experience in building scalable web applications."
  ),
  // Resume link is not provided in the text, so leaving as default for now
  resumeLink: "your-resume-link-here",
  // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  // --- UPDATED ---
  github: "https://github.com/mayanksaini18",
  linkedin: "https://www.linkedin.com/in/mayank-saini-04675b333/",
  gmail: "mayanksaini18@gmail.com",
  // Other links are not present in the resume, so leaving as default
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK", // Leaving as default
  skills: [
    // --- UPDATED (Based on Profile Summary and Web Technologies) ---
    emoji(
      "⚡ Develop responsive web pages using modern tech framework."),
    emoji("⚡ Implement data-driven solutions using Core Java and Python."),
    emoji(
      "⚡ Apply foundational knowledge of Data Structures and Algorithms to solve complex problems."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {skillName: "HTML5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "Bootstrap", fontAwesomeClassname: "fab fa-bootstrap"},
    {skillName: "Tailwind CSS", fontAwesomeClassname: "fas fa-wind"}, // no official Tailwind icon in FA
    {skillName: "React", fontAwesomeClassname: "fab fa-react"},
    {skillName: "Express.js", fontAwesomeClassname: "fas fa-server"}, // no official Express icon in FA
    {skillName: "Node.js", fontAwesomeClassname: "fab fa-node-js"},
    {skillName: "Java", fontAwesomeClassname: "fab fa-java"},
    {skillName: "MongoDB", fontAwesomeClassname: "fas fa-database"}, // generic DB icon
    {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "C/C++", fontAwesomeClassname: "fas fa-code"},
    {skillName: "GitHub", fontAwesomeClassname: "fab fa-github"},
    {skillName: "VS Code", fontAwesomeClassname: "fas fa-laptop-code"},
    // { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    // { skillName: "Kubernetes", fontAwesomeClassname: "fas fa-network-wired" }, // no official FA icon
    // { skillName: "Linux", fontAwesomeClassname: "fab fa-linux" },
    {skillName: "Git", fontAwesomeClassname: "fab fa-git-alt"}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // --- MOVED UP and LOGO UPDATED ---
    {
      schoolName: "Institute of Technology, Patna",
      // NOTE: This assumes you will add a file named 'iitpatnaLogo.png' to your assets/images folder.
      logo: require("./assets/images/iitp_logo.png"),
      subHeader: "Bachelor of Science in Computer Science, AI and Cybersecurity", // Assuming this structure based on the resume's format
      duration: "2025 - 2028",
      descBullets: [
        "Pursuing Computer Science Engineering with a focus on Software Development and Data Structures & Algorithms."
      ]
    }
    // --- MOVED DOWN ---
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    // --- UPDATED (Based on Technical Skills/Profile) ---
    {
      Stack: "Web Development", //Insert stack or technology you have experience in
      progressPercentage: "86%" // Insert a relative proficiency
    },
    {
      Stack: "Data Structures & Algorithms",
      progressPercentage: "65%"
    },
    {
      Stack: "Programming (Java, Python, C/C++)",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    // --- UPDATED (Based on Experience Section) ---
    {
      role: "Web Developer",
      company: "A.L.I.G.N.",
      companylogo: require("./assets/images/ALIGN_logo.png"), // Default image
      date: "September 2025 – Present",
      desc: "Contributed to the development and maintenance of responsive client-facing web pages using modern technologies. Ensured cross-browser compatibility and optimized page performance, resulting in faster load times across different devices.",
      descBullets: [
        "Collaborated with the design team to translate mockups into precise, pixel-perfect user interfaces, focusing on accessibility and usability."
      ]
    },
    // {
    //   role: "Campus Ambassador (Part-time)",
    //   company: "UNLOX®",
    //   companylogo: require("./assets/images/quoraLogo.png"), // Default image
    //   date: "August 2025 – November 2025",
    //   desc: "Represented the organization on campus by actively promoting educational opportunities and events to the student body. Developed strong communication and networking skills by organizing and executing informational sessions."
    // }
    // Removed other default experiences
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "PROJECTS I'VE BUILT TO APPLY MY SKILLS",
  projects: [
    {
      image: require("./assets/images/BuiltX.png"),
      projectName: "Built X – Full-Stack Agency Website",
      projectDesc: "Developed a responsive agency website using Next.js, TypeScript, and Tailwind CSS. Implemented a modular architecture, optimized SEO with Server Components, and added smooth UI animations using Framer Motion.",
      footerLink: [
        {
          name: "https://builtx.vercel.app/",
          url: "#" // add when ready
        }
      ]
    },
    {
      image: require("./assets/images/doable_logo.png"),
      projectName: "Do.able – Smart To-Do Application",
      projectDesc: "Built a productivity-focused To-Do app with task management, progress tracking, and analytics. Designed a clean UI and implemented full-stack functionality using React.js, Node.js, Express, and MongoDB.",
      footerLink: [
        {
          name: "Live Link",
          url: "#" // add when ready
        }
      ]
    },
    {
      image: require("./assets/images/dsaMedEazy.png"),
      projectName: "DSA Med Eazy – DSA Learning Platform",
      projectDesc: "Created an interactive learning platform offering DSA roadmaps, quizzes, and structured concepts. Built with HTML, CSS, Bootstrap, and JavaScript for a user-friendly experience.",
      footerLink: [
        {
          name: "https://dsamedeazy.netlify.app/",
          url: "#" // add when ready
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// The resume does not contain specific certifications/achievements that fit this format, so leaving as default.

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    // {
    //   title: "Your Achievement",
    //   subtitle: "A short description of your achievement",
    //   image: require("./assets/images/your_image.png"),
    //   imageAlt: "Your Achievement Logo",
    //   footerLink: [
    //     {
    //       name: "View Certification",
    //       url: "http://example.com"
    //     }
    //   ]
    // }
  ],
  display: false // Set to false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",

  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  displayMediumBlogs: false, // Set true to display fetched medium blogs instead of hardcoded ones

  blogs: [
    {
      url: "https://www.linkedin.com/posts/activity-7183763478903230465-a2kZ",

      title: "Why REACT is The Best?",

      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    },
    {
      url: "https://www.linkedin.com/pulse/why-did-facebook-engineers-create-react-mayank-saini-zkxhc/?trackingId=z7lCxqjiTt2XLrKw045L%2FQ%3D%3D",

      title: "Why did Facebook engineers create React?",

      description: "Explore the reasons behind the creation of React by Facebook engineers and how it has revolutionized web development."
    }
  ],

  display: true // Set false to hide this section, defaults to true
};

// Talks Sections
// The resume does not contain specific talks, so leaving as default.

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    // {
    //   title: "My Awesome Talk",
    //   subtitle: "Description of the talk",
    //   slides_url: "http://example.com/slides",
    //   event_url: "http://example.com/event"
    // }
  ],
  display: false // Set to false since no new data was provided
};

// Podcast Section
// The resume does not contain a podcast, so leaving as default.

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [],
  display: false // Set to false since no new data was provided
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  // Provide the link to your resume
  resumeLink: "your-resume-link-here",
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // --- UPDATED ---
  number: "", // Number not provided, keeping empty
  email_address: "mayanksaini18@gmail.com"
};

// Twitter Section
// Twitter username not provided in the links, leaving as default

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set to true as the resume is seeking an "Apprenticeship"

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};